module.exports = __webpack_public_path__ + "img/digitalIdentity15.40d6bbf4.png";